import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { PROBLEM_LISTS_FETCH } from "../actions/types";
import { problemListsFetchSuccess } from "../actions/ProblemListActions";
import { showErrorMessage, showSuccessMessage } from "../actions/NotifyActions";
import { authorizationHeader, getErrorMessage } from "../util/apiUtil";
import { intl } from "../lngProvider/IntlGlobalProvider";
import { reset } from "redux-form";
import axios from "axios";
import _ from "lodash";

// API
const problemListsFetchRequest = async payload => {
    let url = `${process.env.REACT_APP_API_URL}/api/problemlists`;
    let params = { ...payload };
    params = _.omitBy(params, _.isEmpty);

    return await axios
        .get(url, {
            headers: authorizationHeader("bearer"),
            params: params
        })
        .then(response => response.data)
        .catch(error => {
            throw error;
        });
};

// WORKER
function* problemListsFetch({ payload }) {
	try {
		const data = yield call(problemListsFetchRequest, payload);
		yield put(problemListsFetchSuccess(data));
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

// WATCHER
function* problemListsFetchWatcher() {
    yield takeEvery(PROBLEM_LISTS_FETCH, problemListsFetch);
}

export default function* rootSaga() {
    yield all([
        fork(problemListsFetchWatcher),
    ]);
}